
export default function Footer() {
  return (
    <footer className="bg-[#F9FAFB] pt-20 pb-8 px-6 lg:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 bg-gradient-to-br from-[#7C3AED] to-[#A855F7] rounded-lg flex items-center justify-center">
                <i className="ri-heart-pulse-line text-white text-xl"></i>
              </div>
              <span className="text-xl font-bold bg-gradient-to-r from-[#7C3AED] to-[#A855F7] bg-clip-text text-transparent">
                MillionDollarMed
              </span>
            </div>
            <p className="text-sm text-gray-600 leading-relaxed">
              Full-service digital marketing agency specializing in HIPAA-compliant patient acquisition
              and practice growth for healthcare providers.
            </p>
          </div>

          <div>
            <h4 className="font-bold text-gray-900 mb-6 text-sm">
              <a href="/sitemap" className="hover:text-[#7C3AED] transition-colors cursor-pointer">
                Services
              </a>
            </h4>
            <ul className="space-y-3">
              <li>
                <a href="/services/medical-website-design" className="text-sm text-gray-600 hover:text-[#7C3AED] transition-colors cursor-pointer">
                  Medical Website Design
                </a>
              </li>
              <li>
                <a href="/services/medical-seo" className="text-sm text-gray-600 hover:text-[#7C3AED] transition-colors cursor-pointer">
                  Medical SEO
                </a>
              </li>
              <li>
                <a href="/services/healthcare-ppc" className="text-sm text-gray-600 hover:text-[#7C3AED] transition-colors cursor-pointer">
                  Healthcare PPC
                </a>
              </li>
              <li>
                <a href="/services/reputation-management" className="text-sm text-gray-600 hover:text-[#7C3AED] transition-colors cursor-pointer">
                  Reputation Management
                </a>
              </li>
              <li>
                <a href="/services/marketing-automation" className="text-sm text-gray-600 hover:text-[#7C3AED] transition-colors cursor-pointer">
                  Marketing Automation
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-gray-900 mb-6 text-sm">
              <a href="/sitemap" className="hover:text-[#7C3AED] transition-colors cursor-pointer">
                Industries
              </a>
            </h4>
            <ul className="space-y-3">
              <li>
                <a href="/industries/bhrt-hormone-therapy" className="text-sm text-gray-600 hover:text-[#7C3AED] transition-colors cursor-pointer">
                  Hormone Therapy
                </a>
              </li>
              <li>
                <a href="/industries/longevity-antiaging" className="text-sm text-gray-600 hover:text-[#7C3AED] transition-colors cursor-pointer">
                  Longevity Medicine
                </a>
              </li>
              <li>
                <a href="/industries/functional-integrative" className="text-sm text-gray-600 hover:text-[#7C3AED] transition-colors cursor-pointer">
                  Functional Medicine
                </a>
              </li>
              <li>
                <a href="/industries/obgyn-menopause" className="text-sm text-gray-600 hover:text-[#7C3AED] transition-colors cursor-pointer">
                  Women&apos;s Health
                </a>
              </li>
              <li>
                <a href="/industries/urology" className="text-sm text-gray-600 hover:text-[#7C3AED] transition-colors cursor-pointer">
                  Men&apos;s Health
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-gray-900 mb-6 text-sm">Company</h4>
            <ul className="space-y-3">
              <li>
                <a href="/about" className="text-sm text-gray-600 hover:text-[#7C3AED] transition-colors cursor-pointer">
                  About Us
                </a>
              </li>
              <li>
                <a href="/automation-platform" className="text-sm text-gray-600 hover:text-[#7C3AED] transition-colors cursor-pointer">
                  Automation Platform
                </a>
              </li>
              <li>
                <a href="/book-strategy-call" className="text-sm text-gray-600 hover:text-[#7C3AED] transition-colors cursor-pointer">
                  Book Strategy Call
                </a>
              </li>
              <li>
                <a href="/sitemap" className="text-sm text-gray-600 hover:text-[#7C3AED] transition-colors cursor-pointer">
                  Sitemap
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-gray-600">
            &copy; 2025 MillionDollarMed. All rights reserved.
          </p>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-gray-500 hover:text-[#7C3AED] transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
